import { render } from "./MediaLibPagination.vue?vue&type=template&id=8fddee70&scoped=true"
import script from "./MediaLibPagination.vue?vue&type=script&lang=ts"
export * from "./MediaLibPagination.vue?vue&type=script&lang=ts"

import "./MediaLibPagination.vue?vue&type=style&index=0&id=8fddee70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8fddee70"

export default script